import { CrewIncentiveTypeEnum, Pegasus } from 'corso-types';
import DescriptionList from '~/components/DescriptionList';
import { useCurrency } from '~/hooks/useCurrency';
import { formatter } from 'corso-web-lib';

export default function EventShopNowDisplay({
  params,
}: {
  params: Pegasus.EventShopNow['params'];
}) {
  const { currencyCode } = useCurrency();
  let incentiveDisplayValue = 'None';
  // ? maybe enforce all incentive kinds are shown
  const shopNowInformational = params.shopNowBenefits.filter(
    (b) => b.kind === 'informational',
  );
  const shopNowIncentives = params.shopNowBenefits.filter(
    (b) => b.kind === 'incentive',
  );
  const [shopNowIncentive] = shopNowIncentives;
  if (shopNowIncentive) {
    if (shopNowIncentive.incentive.type === CrewIncentiveTypeEnum.fixed) {
      incentiveDisplayValue = formatter.currency(
        shopNowIncentive.incentive.amount,
        currencyCode,
      );
    }
    if (shopNowIncentive.incentive.type === CrewIncentiveTypeEnum.percent) {
      incentiveDisplayValue = formatter.percent(
        shopNowIncentive.incentive.amount,
      );
    }
  }

  return (
    <div className="mt-2 flex flex-col gap-4">
      <DescriptionList
        descriptions={[
          {
            term: 'Start Shopping URL',
            details: params.startShoppingUrl,
          },
          {
            term: 'Incentive Offered',
            details: incentiveDisplayValue,
          },
          ...shopNowInformational.map((benefit) => ({
            term: benefit.label,
            details: benefit.description,
            // ? include and display the icon used
          })),
        ]}
      />
    </div>
  );
}
